import { render, staticRenderFns } from "./editQuotation.vue?vue&type=template&id=548ac74d&scoped=true&"
import script from "./editQuotation.vue?vue&type=script&lang=js&"
export * from "./editQuotation.vue?vue&type=script&lang=js&"
import style0 from "./editQuotation.vue?vue&type=style&index=0&id=548ac74d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548ac74d",
  null
  
)

export default component.exports